import { INTEGRATIONS_TYPES } from './integrationTypes';

// What a schedule dropdown carries for "no time window" — a grant with no access window is
// permanent. In config, not a modal's constants: nine modules compare against it.
export const SCHEDULE_PERMANENT = 'permanent';

// The access window's Inner Range (Integriti) TimePeriod link, if it has one.
export const irIntegrationOf = (accessWindow) =>
	accessWindow?.integrations?.find((i) => i.integrationID === INTEGRATIONS_TYPES.INTEGRATION_INNER_RANGE.id) ?? null;

export const isIRLinkedAccessWindow = (accessWindow) => !!irIntegrationOf(accessWindow);

// What an Open Access schedule makes a lock do; the values are the API's `action`.
export const OPEN_ACCESS_DEVICE_ACTION = { HOLD: 'hold', UNLOCK: 'unlock', LOCK: 'lock' };
export const OPEN_ACCESS_DEVICE_ACTION_OPTIONS = [
	{ value: OPEN_ACCESS_DEVICE_ACTION.HOLD, label: 'Stays unlocked', note: 'Locks itself at the end' },
	{ value: OPEN_ACCESS_DEVICE_ACTION.UNLOCK, label: 'Unlocks at start', note: 'Then locks normally' },
	{ value: OPEN_ACCESS_DEVICE_ACTION.LOCK, label: 'Locks at start', note: 'Locks at each start time' }
];

export const openAccessActionLabel = (action) =>
	(OPEN_ACCESS_DEVICE_ACTION_OPTIONS.find((o) => o.value === action) ?? OPEN_ACCESS_DEVICE_ACTION_OPTIONS[0]).label;
